import { AnswerType } from "@/entities/questionaire/answers/AnswerType";
import { Answer } from "@/entities/questionaire/answers/Answer";
import { AnswerVariant } from "@/entities/questionaire/answers/AnswerVariant";
import constants from "@/entities/constants";
import { expectedAnswerType } from "@/entities/questionaire/answers/ExpectedAnswerType";

export class SingleItemAnswer extends Answer {
  variants: AnswerVariant[];
  answer: number | null = null;
  texts: string[] = [];

  constructor(
    PropertyId: number,
    variants: AnswerVariant[],
    answer: number | null = null,
    texts: string[] = []
  ) {
    super(PropertyId);

    this.variants = variants;
    this.answer = answer;
    this.texts = texts;
  }

  static createAnswer(obj: any): SingleItemAnswer {
    let variants: AnswerVariant[] = [];
    if (obj.answerVariants) {
      variants = obj.answerVariants.map(
        (x: {
          id: number;
          text: string;
          expected: boolean | null;
          expectedAnswer: expectedAnswerType | expectedAnswerType.none;
          label?: string;
          scoringValues?: number[];
        }) => {
          return new AnswerVariant(x.id, x.text, x.expectedAnswer,x.label,x.scoringValues);
        }
      );
    }

    return new SingleItemAnswer(obj.id, variants, null, obj.texts);
  }

  getType(): AnswerType {
    return AnswerType.SingleItem;
  }

  isEmpty(): boolean {
    return this.answer === null;
  }

  getComponentName(): string {
    return constants.answerTypes.SingleItemAnswer.componentName;
  }

  getQuizResultObject(): any {
    return {
      propertyId: this.PropertyId,
      answerType: this.getType(),
      singleItem: this.answer
    };
  }
}
